import { create } from 'zustand';
import { persist } from 'zustand/middleware';


const useCategoriesStore = create(persist((set) => (
    {
        categories: [],
        activeCategory: "",
        setActiveCategory: (category) => set({ activeCategory: category }),
        setCategories: (categories) => set({ categories }),
        addCategory: (category) => set((state) => ({ categories: [...state.categories, category] })),
        updateCategory: (category) => set((state) => ({
        categories: state.categories.map((c) => (c._id === category._id ? category : c)),
        })),
        deleteCategory: (categoryId) => set((state) => ({
        categories: state.categories.filter((c) => c._id !== categoryId),
        })),
    }
    ), {
    name: 'categories-store',
    }));

export default useCategoriesStore;